import React from "react";
import { cleanJoin } from "../../../utils/stringUtil";

function NavigationDropdownMenuItem({
  label,
  children,
  displayDropdownMenu = true,
  isHorizontal,
  displayLabel = true,
}) {
  return (
    <div
      className={cleanJoin(
        "navbar-item",
        "is-size-5",
        "has-dropdown",
        "has-background-black",
        displayDropdownMenu ? "is-active" : ""
      )}
    >
      <span
        className={cleanJoin(
          "navbar-link",
          "is-size-5",
          "is-arrowless",
          "has-background-black",
          displayLabel ? "" : "is-hidden"
        )}
      >
        {label}
      </span>
      <div
        className={cleanJoin(
          "navbar-dropdown",
          "is-boxed",
          "is-size-4-desktop is-size-5-touch",
          
          isHorizontal ? "is-flex-desktop" : ""
        )}
      >
        {children}
      </div>
    </div>
  );
}

export default NavigationDropdownMenuItem;
